// ============================================================================
// Contact form — syncs the file input's visible placeholder with the chosen file
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        $(document).on('change', '.contact-form__file-input', function () {
            const $placeholder = $(this).siblings('.contact-form__file-placeholder');
            if (!$placeholder.length) return;
            const file = this.files && this.files[0];
            if (file) {
                $placeholder.text(file.name).removeAttr('data-empty');
            } else {
                $placeholder.text('Choose file to attach').attr('data-empty', '');
            }
        });

        // Reset the file placeholder when the form is reset (e.g. after submitForm success)
        $(document).on('reset', '.contact-form', function () {
            const $ph = $(this).find('.contact-form__file-placeholder');
            $ph.text('Choose file to attach').attr('data-empty', '');
        });
    });
})(jQuery);
